import React from 'react';
import Menu from './app_menu';
import { Card } from 'antd';
import styles from './detail.module.less'

function getItems(key, value) {
  return <div key={key} className={styles.menu}>
    <div className={styles.menuKey}>{`${key}:`}</div>
    <div className={styles.menuValue}>{value}</div>
  </div>
}

function getTitle(title) {
  if (!title) {
    return (<div></div>)
  }
  return (
    <div className={styles.title}>
      <span>{title}</span>
    </div>
  )
}

export default function Detail({ title = '', items = [] }) {
  return (
    <Card className={styles.detail}>
      {getTitle(title)}
      <div className={styles.item}>
        {items.map(item => getItems(item[0], item[1]))}
      </div>
    </Card>
  )
}
